module.exports = __webpack_public_path__ + "img/login_bg.57ccd2aa.png";